"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealersMapStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return ({
        mapContainer: (_a = {
                width: '480px',
                height: '475px'
            },
            _a[theme.breakpoints.down('sm')] = {
                width: '100%',
            },
            _a['& .gm-control-active.gm-fullscreen-control'] = {
                '& img': {
                    display: 'none',
                },
                '& img:first-child': {
                    display: 'block',
                    maxWidth: 'none',
                    boxSizing: 'content-box',
                    top: '50%',
                    left: '50%',
                    pointerEvents: 'none',
                    position: 'absolute',
                    transform: 'translate(-50%,-50%)',
                },
            },
            _a['& .gmnoprint .gm-control-active'] = {
                '&[aria-label="Zoom in"]': {
                    '& img': {
                        display: 'none',
                    },
                    '& img:first-child': {
                        display: 'block',
                        maxWidth: 'none',
                        boxSizing: 'content-box',
                        top: '50%',
                        left: '50%',
                        pointerEvents: 'none',
                        position: 'absolute',
                        transform: 'translate(-50%,-50%)',
                    },
                },
                '&[aria-label="Zoom out"]': {
                    '& img': {
                        display: 'none',
                    },
                    '& img:first-child': {
                        display: 'block',
                        maxWidth: 'none',
                        boxSizing: 'content-box',
                        top: '50%',
                        left: '50%',
                        pointerEvents: 'none',
                        position: 'absolute',
                        transform: 'translate(-50%,-50%)',
                    },
                },
            },
            _a),
        pin: {},
    });
}, { name: 'Checkout_DealersMap' });
exports.default = dealersMapStyles;
